import { useQuery } from '@apollo/client';
import React, { FunctionComponent } from 'react';

import { GET_TEASER_QUERY, Teaser } from 'src/app/models/teaser';

interface MyProps {
  videoId: string;
}

interface MyQueryResult {
  video: {
    teaser?: Teaser;
  };
}

export const VideoTeaser: FunctionComponent<MyProps> = ({ videoId }: MyProps): JSX.Element | null => {
  const { loading, data } = useQuery<MyQueryResult>(
    GET_TEASER_QUERY, { variables: { id: videoId }, fetchPolicy: 'cache-first' }
  );
  return (
    <>
      {!loading && data !== undefined && data.video.teaser && data.video.teaser.teaserAnimation &&
        <div className="bg-jetblack">
          <video
            src={data.video.teaser.teaserAnimation.reference}
            autoPlay
            loop
            width='100%'
            height='100%'
          />
        </div>
      }
    </>
  );
};
